import React from 'react';
import { Link } from 'react-router-dom';
import { getUniverseForumsPath } from '../../../utils/universePaths';
import styles from '../AnimatorDashboard.module.css';

const AnimatorQuickActions = ({ universeSlug }) => {
  const forumsLink = getUniverseForumsPath(universeSlug);

  return (
    <section className={styles.quickActionsSection}>
      <header className={styles.quickActionsHeader}>
        <h2 className={styles.quickActionsTitle}>Outils animateur</h2>
      </header>
      <div className={styles.quickActions}>
        <Link to="/scenes-ia" className={styles.quickActionPrimary}>
          Scènes IA
        </Link>
        <Link to="/rp-activities" className={styles.quickAction}>
          Events &amp; Missions
        </Link>
        <Link to={forumsLink} className={styles.quickAction}>
          Forums RP
        </Link>
        <Link to="/tableau-de-bord" className={styles.quickAction}>
          Mon tableau de bord
        </Link>
      </div>
    </section>
  );
};

export default AnimatorQuickActions;
